var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageSignup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 385.47,
    height: 433.704,
    viewBox: "0 0 385.47 433.704",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#264eb1;}.b{fill:#282f39;}.aa,.ab,.ac,.af,.ag,.c,.j,.l,.q,.r,.t,.v,.x,.y{fill:none;}.c{stroke:#e8e8e8;}.aa,.ab,.ac,.af,.ag,.c,.j,.l,.t,.v,.x{stroke-linecap:round;}.ac,.c{stroke-linejoin:round;}.ac,.af,.c,.x{stroke-width:0.75px;}.d{fill:#0c235b;}.e{fill:#2d3e50;}.f{fill:#ffd7c7;}.g{fill:#18398a;}.h{fill:#e18c77;}.ae,.h{opacity:0.46;}.i{fill:#39374a;}.j{stroke:#e18c77;}.aa,.ab,.af,.ag,.j,.l,.q,.r,.t,.v,.x,.y{stroke-miterlimit:10;}.aa,.ag,.j,.l{stroke-width:0.5px;}.ae,.k{fill:#fb8e77;}.l{stroke:#ffd7c7;}.m{fill:#52527f;}.n{fill:#3c1286;opacity:0.63;}.o,.w{fill:#fff;}.p{fill:#aed3ff;}.q,.r,.t,.x,.y{stroke:#fff;}.q{opacity:0.89;}.s{fill:#6d6ba3;opacity:0.31;}.u{fill:#3c9efa;}.v{stroke:#9487ef;}.w,.y{opacity:0.43;}.z{fill:#ffca01;}.aa{stroke:#ffb1a8;}.ab{stroke:#aed3ff;}.ac{stroke:#eaeaea;}.ad{fill:#0b2053;}.af,.ag{stroke:#fb8e77;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 123.637)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.679 147.237)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 139.654)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M378.8,395.989a9.841,9.841,0,0,1,9.722-9.96l8.924-.108-.105-8.665,17.778-.215.225,18.66a3.162,3.162,0,0,1-3.124,3.2l-14.615.177h0l-18.765.229Z",
    transform: "translate(-378.795 -377.041)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 36.545,
    height: 3.161,
    transform: "translate(36.595 22.733) rotate(179.306)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.454 5.46)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M391.6,384.521c.347.107.631-.32.468-.695-.679-1.562-2.175-4.4-3.454-2.65C387.327,382.941,390.124,384.069,391.6,384.521Z",
    transform: "translate(-388.286 -380.626)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M395.882,383.085c-.178-2.734-3.3-.94-4.841.128a.622.622,0,0,0-.18.757.515.515,0,0,0,.285.28c1.669.64,4.913,1.546,4.736-1.165",
    transform: "translate(-386.969 -380.096)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M390.724,383.287s-.274,3.487,1.951,4.861",
    transform: "translate(-372.562 -373.775)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.311 1.233)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H17.6V19.17H0Z",
    transform: "translate(19.214 19.17) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M3.549,0h5.8a3.868,3.868,0,0,1,3.868,3.868V8.06a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V3.549A3.549,3.549,0,0,1,3.549,0Z",
    transform: "translate(4.049 4.149) rotate(0.694)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M421.715,396.222l16.14-.2-.09-7.441a5.717,5.717,0,0,0-5.785-5.647h0a10.426,10.426,0,0,0-10.3,10.551Z",
    transform: "translate(-421.681 -375.191)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M441.029,396.223l-16.141-.2.093-7.674a5.485,5.485,0,0,1,5.549-5.417h0a10.658,10.658,0,0,1,10.528,10.787Z",
    transform: "translate(-420.003 -375.192)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 21.031,
    height: 3.161,
    rx: 0.557,
    transform: "translate(21.075 21.688) rotate(179.306)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M397.949,299.045l-1.012.219-8.279,126.962h23.406l16.608-96.881,9.086,96.881h22.4l1.025-140.887Z",
    transform: "translate(-373.637 -285.338)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M373.919,204.945l1.348-3.411a1.318,1.318,0,0,0-.568-1.658,1.269,1.269,0,0,0-1.765.659s-.769,1.957-1.275,3.247a.631.631,0,0,1-1.18-.008,4.808,4.808,0,0,1-.079-2.417c.012-.03,2.531-8.877,2.531-8.877a1.267,1.267,0,0,0-.874-1.566,1.672,1.672,0,0,0-1.646,1.157l-1.75,6.165a.607.607,0,0,1-.626.439l-.2-.014a.632.632,0,0,1-.589-.63l.008-8.033a1.318,1.318,0,0,0-1.136-1.336,1.269,1.269,0,0,0-1.4,1.261l-.008,7.814a.828.828,0,0,1-.7.818.942.942,0,0,1-1.077-.784l-1.083-6.9a1.318,1.318,0,0,0-1.329-1.142,1.269,1.269,0,0,0-1.186,1.464l1.124,7.167a2.234,2.234,0,0,1-.231,1.39.664.664,0,0,1-1.2-.068l-1.186-3.043a1.319,1.319,0,0,0-1.544-.828,1.269,1.269,0,0,0-.845,1.684l2.446,6.692a46.216,46.216,0,0,0,3.623,9.1l9.9-2A17.57,17.57,0,0,0,373.919,204.945Z",
    transform: "translate(-355.366 -188.656)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M474.455,317.195q-3.771-18.818-8.1-37.52-2.156-9.357-4.416-18.689c-1.291-5.339-2.162-11.114-4.984-15.91a17.879,17.879,0,0,0-2.15-2.947c-3.8-4.2-9.7-5.986-15.357-6.014-6.9-.034-13.657,2.228-20.335,3.673-5.728,1.24-12.38,1.744-17.559,4.7l-11.283-5.767L371.7,203.227l-2.195.442-9.9,2-.588.119,10.586,40.322a13.334,13.334,0,0,0,3.623,5.991,45.475,45.475,0,0,0,7.531,6.081l7.586,5.354,9.258,6.536c4.968,24.037,9.82,48.1,14.7,72.157l.125-.027,1.013-.219,63.228-13.706Z",
    transform: "translate(-353.454 -181.036)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M378.278,242.827l14.022,3.018.74,30.355-5.5-26.837Z",
    transform: "translate(-343.385 -160.329)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.966 5.025)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.257 13.696)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M425.192,217.859l-1.039-4.6-.761-3.376-1.879-8.323c-.047-.209-.114-.407-.171-.611-4.913,2.216-15.22,1.223-15.22,1.223a8.2,8.2,0,0,0-3,1.43,6.74,6.74,0,0,0-2.47,4.508c-.19,2,.452,4.03.778,5.988.149.9.331,1.8.475,2.7a3.255,3.255,0,0,1,.146,1.294c-1.438,3.612.355-4.392-8.441-4.052a5.134,5.134,0,0,0-.544.306,4.808,4.808,0,0,0-1.98,5.024l.036.16a4.814,4.814,0,0,0,5.755,3.635l1.215-.276.177.781.056.248a13.529,13.529,0,0,0,1.575,3.94l3.035,14a8.443,8.443,0,0,0,10.042,6.463l.28-.061a8.444,8.444,0,0,0,6.463-10.042l-1.2-5.534A13.537,13.537,0,0,0,425.192,217.859Z",
    transform: "translate(-390.971 -200.949)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M422.745,212.18l-.084-.37a12.709,12.709,0,0,1-9.6,15.2l-.42.094a12.709,12.709,0,0,1-15.2-9.6l-.148-.658-1.649.372.233,1.029a13.485,13.485,0,0,0,9.468,10.021l12.045,4.96-1.317-6.216A13.537,13.537,0,0,0,422.745,212.18Z",
    transform: "translate(-388.525 -195.27)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M402.486,222.8a3.255,3.255,0,0,0-.146-1.294c-.145-.9-.326-1.8-.475-2.7-.326-1.958-.969-3.987-.778-5.988a6.74,6.74,0,0,1,2.47-4.508,8.2,8.2,0,0,1,3-1.43s10.307.993,15.22-1.223a4.144,4.144,0,0,0,2.383-2.191c2.016-5.583-.344-12.189-10.532-11.448a18.233,18.233,0,0,0-7.287,2.2,17.488,17.488,0,0,0-5.039.554,16.835,16.835,0,0,0-6.469,3.066,12.106,12.106,0,0,0-3.434,4.458,14.924,14.924,0,0,0-1.2,5.048,22.16,22.16,0,0,0,.228,4.837,28.749,28.749,0,0,0,.873,3.871c.184.62.393,1.23.618,1.837a.293.293,0,0,0,.143.19.287.287,0,0,0,.21-.032c.4-.172.806-.349,1.212-.513.043.343.079.685.12,1.028a.3.3,0,0,0,.055.164c.064.075.3.027.393.023C402.841,218.408,401.049,226.412,402.486,222.8Z",
    transform: "translate(-390.146 -191.955)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.615 16.43)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.916)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M412.077,204.413a2.186,2.186,0,0,1-.908-.018c-.32-.049-.643-.09-.923-.116s-.606-.044-.93-.055a2.148,2.148,0,0,1-.894-.149c-.232-.123-.3-.426.017-.76a2.5,2.5,0,0,1,1.972-.557,2.427,2.427,0,0,1,1.812.908C412.466,204.051,412.332,204.334,412.077,204.413Z",
    transform: "translate(-408.223 -202.744)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M406.293,209.81a.8.8,0,1,1-.956-.6A.8.8,0,0,1,406.293,209.81Z",
    transform: "translate(-387.144 -199.375)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M411.57,208.551a.8.8,0,1,1-.956-.6A.8.8,0,0,1,411.57,208.551Z",
    transform: "translate(-384.385 -200.033)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M407.128,218.763a2.179,2.179,0,0,1,2.434.218",
    transform: "translate(-385.881 -194.515)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.195 3.118)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M401.757,208.038a2.511,2.511,0,0,0,.764-.6c.244-.247.493-.487.719-.69s.49-.428.76-.646a2.487,2.487,0,0,0,.675-.7c.123-.25,0-.539-.467-.6a2.786,2.786,0,0,0-2.015.825,2.693,2.693,0,0,0-1.007,1.9C401.21,208,401.492,208.138,401.757,208.038Z",
    transform: "translate(-401.184 -204.792)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M393.176,211.354l1.77,2.267-1.432,1.088",
    transform: "translate(-393.176 -198.242)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.298 14.488)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M402.162,212.281A21.36,21.36,0,0,0,407.771,214c2.83.379.641,5.108-3.673,4.765S399.849,211.817,402.162,212.281Z",
    transform: "translate(-400.595 -212.258)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M401.89,213.967a1.828,1.828,0,0,1,1.211,2.283",
    transform: "translate(-399.917 -211.364)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M404.769,210.717a1.579,1.579,0,0,1,1.706-.432",
    transform: "translate(-387.114 -198.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M410.125,209.457a1.579,1.579,0,0,1,1.706-.433",
    transform: "translate(-384.314 -199.519)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M407.659,207.059l2.881,5.16a2.017,2.017,0,0,1-1.358,2.959l-2.036.416",
    transform: "translate(-385.871 -200.488)"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.281)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.048 22.639)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "m",
    width: 199.847,
    height: 408.443,
    rx: 13.049
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 189.089,
    height: 398.411,
    rx: 13.387,
    transform: "translate(5.379 4.134)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.378 15.276)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "o",
    width: 176.253,
    height: 300.067,
    transform: "translate(0 34.759)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 176.253,
    height: 20.322,
    transform: "translate(0.008 34.762)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.834)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M495.617,138.221a3.017,3.017,0,1,1,1.141-.716A2.979,2.979,0,0,1,495.617,138.221Z",
    transform: "translate(-475.661 -132.367)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M517.534,144.434a2.258,2.258,0,0,1-.743.125h0l-33.365,0a2.286,2.286,0,0,1-2.284-2.284,2.285,2.285,0,0,1,2.286-2.284h33.365a2.285,2.285,0,0,1,2.286,2.284A2.3,2.3,0,0,1,517.534,144.434Z",
    transform: "translate(-481.14 -128.383)"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "r",
    cx: 12.96,
    cy: 12.96,
    r: 12.96,
    transform: "translate(84.58 388.488) rotate(-77.376)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "s",
    cx: 9.967,
    cy: 9.967,
    r: 9.967,
    transform: "translate(90.092 368.529)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(173.22 56.676)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "t",
    x2: 5.773,
    y2: 5.773
  }), /*#__PURE__*/React.createElement("line", {
    className: "t",
    x1: 5.773,
    y2: 5.773
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(78.767 316.553)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(112.077)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "u",
    width: 66.307,
    height: 23.86,
    rx: 2.34,
    transform: "translate(16.562 23.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 66.307,
    height: 23.86,
    rx: 2.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M529.977,324.14a2.251,2.251,0,1,1-2.251-2.251A2.251,2.251,0,0,1,529.977,324.14Z",
    transform: "translate(-507.541 -311.905)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M547.89,324.14a2.251,2.251,0,1,1-2.251-2.251A2.251,2.251,0,0,1,547.89,324.14Z",
    transform: "translate(-498.174 -311.905)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M539.082,324.14a2.251,2.251,0,1,1-2.251-2.251A2.251,2.251,0,0,1,539.082,324.14Z",
    transform: "translate(-502.78 -311.905)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 13.678)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 104.987,
    height: 35.982,
    rx: 3.011
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.018 7.525)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "p",
    cx: 11.036,
    cy: 11.036,
    r: 11.036
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M455.748,347.616a11.036,11.036,0,0,1-11.035-11.036c0-.073,11.035-.227,11.035-.227S455.781,347.616,455.748,347.616Z",
    transform: "translate(-444.713 -325.544)"
  })), /*#__PURE__*/React.createElement("line", {
    className: "t",
    x2: 53.624,
    transform: "translate(36.627 11.705)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "t",
    x2: 17.655,
    transform: "translate(36.627 17.975)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "t",
    x2: 32.07,
    transform: "translate(36.627 25.321)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "v",
    x2: 17.655,
    transform: "translate(60.943 17.975)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.693 139.881)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 98.335,
    height: 98.335,
    rx: 2.553
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M2.184,0H36.947a2.184,2.184,0,0,1,2.184,2.184V36.947a2.184,2.184,0,0,1-2.184,2.184H2.185A2.185,2.185,0,0,1,0,36.947V2.184A2.184,2.184,0,0,1,2.184,0Z",
    transform: "translate(9.272 15.614)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.705 26.074)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M455.97,216.465l-22.379-.021a.938.938,0,0,0-.938.937l0,2.4v1.177l-.011,11.577V233.7a.934.934,0,0,0,.935.937l22.381.021a.937.937,0,0,0,.937-.937v-1.093l.011-12.532,0-1.173,0-1.518A.937.937,0,0,0,455.97,216.465Z",
    transform: "translate(-432.639 -216.444)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M442.072,224.589l2.453,1.29a.481.481,0,0,0,.463-.006l10.9-6.4.821-.481a.539.539,0,0,1,.189-.067l0-1.518a.937.937,0,0,0-.937-.937l-22.379-.021a.938.938,0,0,0-.938.937l0,2.4.591.3Z",
    transform: "translate(-432.635 -216.444)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M432.65,219.411l-.01,11.577,8.678-7.16Z",
    transform: "translate(-432.639 -214.893)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M451.574,231.371l.011-12.531L442.809,224Z",
    transform: "translate(-427.321 -215.191)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M456.282,230.265l-9.115-7.669-1.651.97a1.572,1.572,0,0,1-.764.2,1.523,1.523,0,0,1-.711-.177l-1.729-.909a.5.5,0,0,1-.082.088l-9.063,7.477a.522.522,0,0,1-.334.12.537.537,0,0,1-.195-.04v.152a.934.934,0,0,0,.935.937l22.381.021a.937.937,0,0,0,.937-.937v-.192a.529.529,0,0,1-.273.079A.522.522,0,0,1,456.282,230.265Z",
    transform: "translate(-432.639 -213.227)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(74.425 8.968)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 1.603,
    cy: 1.603,
    r: 1.603
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 1.603,
    cy: 1.603,
    r: 1.603,
    transform: "translate(6.669)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 1.603,
    cy: 1.603,
    r: 1.603,
    transform: "translate(12.827)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.141 74.049)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "r",
    cx: 2.805,
    cy: 2.805,
    r: 2.805
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M458.016,250.751a2.8,2.8,0,1,1-2.8-2.8A2.8,2.8,0,0,1,458.016,250.751Z",
    transform: "translate(-440.738 -247.946)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "r",
    cx: 2.805,
    cy: 2.805,
    r: 2.805,
    transform: "translate(22.444)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.468 24.057)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "t",
    x2: 28.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "t",
    x2: 28.52,
    transform: "translate(0 11.123)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "t",
    x2: 28.52,
    transform: "translate(0 22.245)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 79.584,
    height: 20.119,
    rx: 5.353,
    transform: "translate(9.272 67.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 79.584,
    height: 20.119,
    rx: 5.353,
    transform: "translate(9.272 67.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160.229 136.098)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "u",
    width: 123.119,
    height: 169.669,
    rx: 4.072
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.029 18.172)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 97.75,
    height: 17.842,
    rx: 1.507
  }), /*#__PURE__*/React.createElement("line", {
    className: "t",
    x2: 29.025,
    transform: "translate(10.505 6.719)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "t",
    x2: 12.094,
    transform: "translate(43.696 6.719)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "t",
    x2: 12.094,
    transform: "translate(43.696 12.532)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M565.593,216.314a4.178,4.178,0,1,1-4.177-4.177A4.178,4.178,0,0,1,565.593,216.314Z",
    transform: "translate(-474.347 -207.011)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.029 46.659)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "t",
    x1: 29.025,
    transform: "translate(61.59 11.827)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "t",
    x1: 12.094,
    transform: "translate(45.33 11.827)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "t",
    x1: 12.094,
    transform: "translate(45.33 6.014)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 97.75,
    height: 17.842,
    rx: 1.507
  }), /*#__PURE__*/React.createElement("circle", {
    className: "w",
    cx: 4.178,
    cy: 4.178,
    r: 4.178,
    transform: "translate(6.327 4.743)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.029 76.005)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 97.75,
    height: 17.842,
    rx: 1.507
  }), /*#__PURE__*/React.createElement("line", {
    className: "t",
    x2: 29.025,
    transform: "translate(10.505 6.719)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "t",
    x2: 12.094,
    transform: "translate(43.696 6.719)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "t",
    x2: 12.094,
    transform: "translate(43.696 12.532)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 4.178,
    cy: 4.178,
    r: 4.178,
    transform: "translate(82.891 5.126)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.029 135.129)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 97.75,
    height: 17.842,
    rx: 1.507
  }), /*#__PURE__*/React.createElement("line", {
    className: "t",
    x2: 29.025,
    transform: "translate(10.505 6.719)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "t",
    x2: 12.094,
    transform: "translate(43.696 6.719)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "t",
    x2: 12.094,
    transform: "translate(43.696 12.532)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 4.178,
    cy: 4.178,
    r: 4.178,
    transform: "translate(82.891 5.126)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.029 104.492)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "t",
    x1: 29.025,
    transform: "translate(61.59 11.827)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "t",
    x1: 12.094,
    transform: "translate(45.33 11.827)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "t",
    x1: 12.094,
    transform: "translate(45.33 6.014)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 97.75,
    height: 17.842,
    rx: 1.507
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M515.318,272.744a4.178,4.178,0,1,1-4.177-4.177A4.177,4.177,0,0,1,515.318,272.744Z",
    transform: "translate(-500.635 -263.823)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(226.066)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "z",
    cx: 29.935,
    cy: 29.935,
    r: 29.935
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.747 14.719)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M570.953,137.68H551.758a4.592,4.592,0,0,1-4.591-4.592h0a4.591,4.591,0,0,1,4.591-4.59h19.195a4.591,4.591,0,0,1,4.59,4.59h0A4.592,4.592,0,0,1,570.953,137.68Z",
    transform: "translate(-547.167 -111.195)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M559.879,117.136h0a9.888,9.888,0,0,0-9.888,9.887v10.712h19.775V127.023A9.888,9.888,0,0,0,559.879,117.136Z",
    transform: "translate(-545.69 -117.136)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M562.245,135.775a4.288,4.288,0,1,1-4.288-4.288A4.289,4.289,0,0,1,562.245,135.775Z",
    transform: "translate(-543.768 -109.632)"
  })), /*#__PURE__*/React.createElement("line", {
    className: "aa",
    x1: 6.3,
    transform: "translate(18.753 31.829)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "aa",
    x1: 6.3,
    transform: "translate(37.057 31.829)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "aa",
    x1: 10.878,
    transform: "translate(25.485 41.501)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.58 248.923)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "u",
    width: 136.561,
    height: 73.614,
    rx: 1.431
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(78.94 8.77)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "p",
    cx: 19.932,
    cy: 19.932,
    r: 19.932,
    transform: "matrix(0.63, -0.776, 0.776, 0.63, 0, 30.954)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.224 18.964)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 5.066,
    cy: 5.066,
    r: 5.066,
    transform: "translate(3.716)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M477.4,305.106H463.677a1.92,1.92,0,0,1-1.919-1.92h0a7.125,7.125,0,0,1,7.124-7.126h4.211a6.231,6.231,0,0,1,6.23,6.23v.9A1.921,1.921,0,0,1,477.4,305.106Z",
    transform: "translate(-461.758 -285.514)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.197 5.65)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "t",
    x2: 5.773,
    y2: 5.773
  }), /*#__PURE__*/React.createElement("line", {
    className: "t",
    x1: 5.773,
    y2: 5.773
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.925 25.182)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "t",
    x2: 26.138
  }), /*#__PURE__*/React.createElement("line", {
    className: "t",
    x2: 23.297,
    transform: "translate(32.933)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "t",
    x2: 23.297,
    transform: "translate(0 23.249)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "t",
    x2: 23.297,
    transform: "translate(22.049 10.971)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ab",
    x2: 15.293,
    transform: "translate(0 10.971)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ab",
    x2: 9.402,
    transform: "translate(30.461 23.249)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 84.154)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "u",
    width: 236.362,
    height: 39.238,
    rx: 12.158
  }), /*#__PURE__*/React.createElement("rect", {
    className: "o",
    width: 153.945,
    height: 19.424,
    rx: 1.04,
    transform: "translate(54.288 9.907)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.394 10.627)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M414.97,176.307a6.6,6.6,0,1,1-6.6-6.6A6.573,6.573,0,0,1,414.97,176.307Z",
    transform: "translate(-401.774 -169.708)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "t",
    x1: 7.2,
    y1: 7.2,
    transform: "translate(11.718 10.783)"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(316.603 141.487)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 44.783)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 64.23)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.004 161.912)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M599.848,378.278v6.282h-4.065a9.538,9.538,0,0,0-9.538,9.538h23a3.493,3.493,0,0,0,3.494-3.494V378.278Z",
    transform: "translate(-586.246 -378.278)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 26.491,
    height: 2.292,
    transform: "translate(26.491 16.48) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.582 3.776)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M595.577,383.6c.25.081.46-.227.346-.5-.48-1.139-1.538-3.207-2.481-1.951S594.51,383.259,595.577,383.6Z",
    transform: "translate(-593.194 -380.758)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M598.693,382.588c-.105-1.983-2.38-.71-3.509.05a.447.447,0,0,0-.137.547.368.368,0,0,0,.2.206c1.2.478,3.548,1.163,3.443-.8",
    transform: "translate(-592.247 -380.354)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M594.947,382.7s-.229,2.525,1.372,3.541",
    transform: "translate(-581.702 -375.965)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 161.912)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M576.865,378.278v6.282H572.8a9.538,9.538,0,0,0-9.538,9.538h23a3.493,3.493,0,0,0,3.493-3.494V378.278Z",
    transform: "translate(-563.261 -378.278)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 26.491,
    height: 2.292,
    transform: "translate(26.491 16.48) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.582 3.776)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M572.592,383.6c.251.081.46-.227.346-.5-.48-1.139-1.538-3.207-2.481-1.951S571.525,383.259,572.592,383.6Z",
    transform: "translate(-570.209 -380.758)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M575.709,382.588c-.107-1.983-2.38-.71-3.51.05a.451.451,0,0,0-.137.547.375.375,0,0,0,.2.206c1.2.478,3.547,1.163,3.443-.8",
    transform: "translate(-569.262 -380.354)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M571.963,382.7s-.23,2.525,1.371,3.541",
    transform: "translate(-558.717 -375.965)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M623.826,283.965l-4.639-12.005L576.753,275l-6.6,159.665h19.461l8.516-97.659,6.294,98.107,20.152-.448L628.508,310.5A69.873,69.873,0,0,0,623.826,283.965Z",
    transform: "translate(-559.655 -271.96)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.549)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M622.983,287.139q-.217-8.532-.434-17.066c-.229-9.009,1.4-19.441-1.1-28.193-1.881-6.579-8.513-12.54-15.593-12.071l-2.328.158-15.185-.123c-9.025-.072-13.788,3.414-13.88,14.7,0,0,.451,46.448.043,52.511-.065.982,20.7-.535,33.6-1.78a8.2,8.2,0,0,0,6.174,2.1A9.508,9.508,0,0,0,622.983,287.139Z",
    transform: "translate(-562.954 -229.784)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M619.336,263.706l-36.081-4.834,0-.006-1.392-.155c-1.675-.186-3.222,1.537-5.18,2.688l-9.064,6.3a1.205,1.205,0,0,0-.607,1.588,1.188,1.188,0,0,0,1.275.676c-.038.04-.075.079-.113.122l-.133.058a1.2,1.2,0,1,0,.981,2.2l.012,0a1.182,1.182,0,0,0,.015.842,1.207,1.207,0,0,0,1.572.649l.5-.21c.031,0,.049.012.079.015l.079.05a1.057,1.057,0,0,0-.195,1.019,1.073,1.073,0,0,0,1.363.652s11.114-2.539,15.068-4.363l26.911,10.726a9.374,9.374,0,1,0,4.908-18.011Z",
    transform: "translate(-566.905 -214.665)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M599.353,245.471v23.737l-14.43-1.933,13.3.234,1.125-22.037",
    transform: "translate(-557.483 -221.581)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.479)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M621.879,228.924a14.473,14.473,0,0,0-8.958-12.57,7.379,7.379,0,0,0,.731-3.687,7.027,7.027,0,0,0-7.388-6.7,6.624,6.624,0,0,0-1.875.443c-2.619-3.693-7.132-6.488-14.868-5.976-12.031.8-15.554,9.367-16.19,11.266a7.321,7.321,0,0,0-.662,10.429,14.938,14.938,0,0,0-1.389,7.357A14.171,14.171,0,0,0,586.181,243a13.771,13.771,0,0,0,9.9-5.379,13.818,13.818,0,0,0,12.809,6.8C616.593,243.869,622.407,236.931,621.879,228.924Z",
    transform: "translate(-570.798 -200.377)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.572 9.879)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M604.253,217.989c-2.828.611-5.292,3.321-5.584,4.544-.1.42,1.074-6.7.644-6.661-4.508.39-4.592-6.7-4.592-6.7-.79,2.842-7.094,2.626-13.01,1.751-.836-.125-1.69-4.059-1.69-4.059s-1.013,3.358-1.757,3.207c-.469-.094-.947-.189-1.424-.282-.044.242-.094.481-.125.729l-1.477,12.366v0h0l-.032.268a12.808,12.808,0,0,0,11.2,14.239h0c.294.035.585.046.877.059l.183,8.16a6.554,6.554,0,0,0,13.1-.294l-.381-16.989a12.676,12.676,0,0,0,.422-1.945h0l.914.11a4.549,4.549,0,0,0,2.731-8.505Z",
    transform: "translate(-575.114 -206.864)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M585.747,230.748a12.022,12.022,0,0,1-10.509-13.363l-.032.268a12.808,12.808,0,0,0,11.2,14.239h0c.294.035.585.044.876.059l.139,7.444,9.422-11.024-.009,0a12.755,12.755,0,0,0,3.78-7.491l-1.575-.187A12.015,12.015,0,0,1,585.747,230.748Z",
    transform: "translate(-575.114 -201.363)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.202 4.548)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M581.737,215.294a.744.744,0,1,0,.827-.65A.745.745,0,0,0,581.737,215.294Z",
    transform: "translate(-572.855 -207.347)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M576.9,214.6a.744.744,0,1,0,.827-.65A.744.744,0,0,0,576.9,214.6Z",
    transform: "translate(-575.385 -207.711)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M580.807,212.932l-2.872,5.569a.277.277,0,0,0-.012.271c.157.33.717,1.068,2.6,1.09",
    transform: "translate(-574.863 -208.239)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M580.532,223.525a2.024,2.024,0,0,0-2.114-.836",
    transform: "translate(-574.588 -203.171)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.033 2.199)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M586.621,213.86a2.541,2.541,0,0,1-1.01-.286c-.343-.149-.691-.289-1-.4s-.666-.228-1.023-.337a2.5,2.5,0,0,1-.956-.429c-.222-.207-.215-.565.241-.845a2.9,2.9,0,0,1,2.37-.044,2.805,2.805,0,0,1,1.76,1.549C587.162,213.569,586.929,213.845,586.621,213.86Z",
    transform: "translate(-582.491 -211.294)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M576.169,211.467a2.014,2.014,0,0,0,.844-.046c.3-.055.594-.1.856-.136s.562-.061.862-.081a2.041,2.041,0,0,0,.827-.168c.212-.123.27-.407-.038-.707a2.335,2.335,0,0,0-1.852-.457,2.262,2.262,0,0,0-1.658.9C575.8,211.143,575.93,211.4,576.169,211.467Z",
    transform: "translate(-575.903 -209.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M594.142,215.726l-1.42,2.267,1.429.87",
    transform: "translate(-567.109 -206.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M583.981,222.066l1.229-.774a3.26,3.26,0,0,0,1.022-4.494l-.1-.157-4.672,2.942,1.4,2.23A.809.809,0,0,0,583.981,222.066Z",
    transform: "translate(-572.997 -206.3)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageSignup);
export default __webpack_public_path__ + "static/media/image-signup.2e5afc45f639cc51f396377c02c9db01.svg";
export { ForwardRef as ReactComponent };